import {
  barType,
  ChartWidgetTypeCategory,
  DateRange,
  KpiWidgetPrebuiltType,
  pieType,
  TableWidgetPrebuiltType,
  TermometerOptions,
  Widget,
  WidgetChartConfig,
  WidgetFilterSelectDataType,
  WidgetFilterType,
  WidgetMachineDataType,
  WidgetType
} from './widget-models';

// Predefined configurations for widgets
export const prebuilt_widgets: Widget[] = [
  {
    id: 'TextWidget',
    config: {
      generic: {
        description: '',
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {}
    },
    widgetType: WidgetType.TEXT,
    widgetTypeCategory: null,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemRows: 4,
    dragEnabled: true
  },
  {
    id: 'WidgetKpi',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {
        orientation: 'vertical'
      }
    },
    widgetType: WidgetType.KPI,
    widgetTypeCategory: KpiWidgetPrebuiltType.STANDARD,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 4,
    dragEnabled: true
  },
  {
    id: 'AlertKpi',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false,
        canNavigate: true,
        routeTo: 'app/faults'
      },
      specific: {}
    },
    widgetType: WidgetType.KPI,
    widgetTypeCategory: KpiWidgetPrebuiltType.ALERT,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 2,
    dragEnabled: true
  },
  {
    id: 'RecapKpi',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false,
        canNavigate: true,
        routeTo: 'app/manage/vehicles',
      },
      specific: {}
    },
    widgetType: WidgetType.KPI,
    widgetTypeCategory: KpiWidgetPrebuiltType.VEHICLES_RECAP,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 2,
    dragEnabled: true
  },
  {
    id: 'MaintenanceKpi',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false,
        canNavigate: true,
        routeTo: 'app/maintenance/deadlines',
      },
      specific: {}
    },
    widgetType: WidgetType.KPI,
    widgetTypeCategory: KpiWidgetPrebuiltType.MAINTENANCE,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 2,
    dragEnabled: true
  },
  {
    id: 'OverviewWidget',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {}
    },
    widgetType: WidgetType.MACHINE_DATA,
    widgetTypeCategory: WidgetMachineDataType.OVERVIEW,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 2,
    dragEnabled: true
  },
  {
    id: 'MachineAlertKpi',
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false,
        canNavigate: true,
        routeTo: 'app/faults',
      },
      specific: {}
    },
    widgetType: WidgetType.KPI,
    widgetTypeCategory: KpiWidgetPrebuiltType.MACHINE_ALERT,
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    //maxItemCols: 2,
    //maxItemRows: 2,
    dragEnabled: true
  },
  {
    id: 'PieWidget',
    widgetType: WidgetType.PIE,
    isCompositeWidget: false,
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {
        type: 'pie' as pieType,
        showLegend: true,
        legendPosition: 'bottom'
      } as WidgetChartConfig
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 4,
    //maxItemCols: 3,
    //maxItemRows: 3
    // resizeEnabled: false,
    dragEnabled: true
  },
  {
    id: 'GaugeWidget',
    widgetType: WidgetType.PIE,
    isCompositeWidget: false,
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {
        type: 'gauge' as pieType,
        showLegend: true,
        legendPosition: 'bottom'
      } as WidgetChartConfig
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 4,
    //maxItemCols: 3,
    //maxItemRows: 3
    // resizeEnabled: false,
    dragEnabled: true
  },
  {
    id: 'TermometerWidget',
    widgetType: WidgetType.PIE,
    isCompositeWidget: false,
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false
      },
      specific: {
        type: 'termometer' as pieType,
        showLegend: false,
        termometer: new TermometerOptions()
      } as WidgetChartConfig
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 4,
    //maxItemCols: 3,
    //maxItemRows: 3
    // resizeEnabled: false,
    dragEnabled: true
  },
  {
    id: 'TableWidget',
    widgetType: WidgetType.TABLE,
    config: {
      generic: {
        canExport: true,
        canNavigate: false
      },
      specific: {
        showFilter: false,
        showPagination: true,
      }
    },
    x: 0,
    y: 0,
    cols: 6,
    rows: 4,
    dragEnabled: true
  },
  {
    id: TableWidgetPrebuiltType.AttivitaVeicoli,
    widgetType: WidgetType.TABLE,
    widgetTypeCategory: TableWidgetPrebuiltType.AttivitaVeicoli,
    config: {
      generic: {
        canExport: true,
        canNavigate: true
      },
      specific: {}
    },
    x: 0,
    y: 0,
    cols: 6,
    rows: 4,
    dragEnabled: true
  },
  {
    id: TableWidgetPrebuiltType.ScadenzeManutenzioni,
    widgetType: WidgetType.TABLE,
    widgetTypeCategory: TableWidgetPrebuiltType.ScadenzeManutenzioni,
    config: {
      generic: {
        canExport: true,
        canNavigate: true
      },
      specific: {}
    },
    x: 0,
    y: 0,
    cols: 6,
    rows: 4,
    dragEnabled: true
  },
  {
    id: 'SignalWidget',
    widgetType: WidgetType.SIGNAL,
    widgetTypeCategory: ChartWidgetTypeCategory.LINE,
    config: {
      generic: {
        canDownloadChart: true,
      },
      specific: {
        showLegend: true,
        legendOrient: 'horizontal',
        legendPosition: 'top',
        type: 'vertical' as barType,
        lineStyle: 'line+points',
      }
    },
    x: 0,
    y: 0,
    cols: 6,
    rows: 4,
    dragEnabled: true
  },
  {
    id: WidgetFilterType.DATE,
    widgetType: WidgetType.FILTER,
    widgetTypeCategory: WidgetFilterType.DATE,
    config: {
      generic: {},
      specific: {
        defaultValue: DateRange.TwentyFourHours
      }
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 2,
    //minItemCol: 4,
    //maxItemRows: 4,
    dragEnabled: true
  },
  {
    id: 'MapWidget',
    widgetType: WidgetType.MAP,
    config: {
      generic: {
        canDownloadChart: false,
        canExport: false,
        canExpand: false,
        canNavigate: true,
        routeTo: 'app/actiaMap',
      },
      specific: {}
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 4,
    dragEnabled: true
  },
  {
    id: WidgetFilterType.SELECT,
    widgetType: WidgetType.FILTER,
    widgetTypeCategory: WidgetFilterType.SELECT,
    config: {
      generic: {},
      specific: {
        selectType: 'single',
        selectDataType: WidgetFilterSelectDataType.VEHICLES
      }
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 2,
    //maxItemCols: 4,
    //maxItemRows: 4,
    dragEnabled: true
  },
  {
    id: 'DividerWidget',
    widgetType: WidgetType.DIVIDER,
    widgetTypeCategory: null,
    config: {
      generic: {},
      specific: {
        orientation: 'horizontal',
        color: 'var(--main-color)',
        width: 12
      }
    },
    x: 0,
    y: 0,
    cols: 3,
    rows: 2,
    dragEnabled: true
  },
  {
    id: 'ImageWidget',
    widgetType: WidgetType.IMAGE,
    widgetTypeCategory: null,
    config: {
      generic: {},
      specific: {}
    },
    x: 0,
    y: 0,
    cols: 4,
    rows: 3,
    dragEnabled: true
  }
];
